let Util = (function () {
    let lambdaHost         = (window.MonroConfig && window.MonroConfig.lambdaHost)     || '';
    let lambdaApiKey       = (window.MonroConfig && window.MonroConfig.lambdaKey)      || '';

    // --- APPOINTMENTS ---
    let lambdaHostAppt   = (window.MonroConfig && window.MonroConfig.lambdaHostAppt) || '';
    let lambdaApiKeyAppt = (window.MonroConfig && window.MonroConfig.lambdaKeyAppt)  || '';

    // --- EMAIL VALIDATION API ---
    let emailApiHost       = (window.MonroConfig && window.MonroConfig.emailApiHost)   || '';
    let emailApiKey        = (window.MonroConfig && window.MonroConfig.emailApiKey)    || '';

    const s3ImageUrl = 'https://monro-images.s3.amazonaws.com/Dev/';

  let breakpoints = {
    'xs': 0,
    'sm': 576,
    'md': 768,
    'lg': 992,
    'xl': 1200,
    'xxl': 1440,
    'xxxl': 1600
  }

  const timeZones = {
      '1': 'America/New_York',
      '2': 'America/Chicago',
      '3': 'America/Denver',
      '4': 'America/Los_Angeles',
  }

  //For accessiblity, set the title of an iframe given the element's ID and the title text as params
  let setiFrameTitle = function (elementId, titleText) {
    jQuery('#' + elementId).find('iframe').prop('title', titleText);
  }

  //Scroll to top of page
  let scrollToTop = function () {
    jQuery('html').animate({
      scrollTop: 0
    }, 600);
  }

  let closestLocationsMapZoom = function (brandId) {
    let zoomCoords = {
      '1': {
        lat: 41.90167,
        lng: -78.74153,
        zoom: 6
      }, //Monro
      '2': {
        lat: 39.90167,
        lng: -79.74153,
        zoom: 6
      }, //Mr Tire
      '3': {
        lat: 38.6527,
        lng: -85.7585,
        zoom: 6
      }, //Tire Barn
      '4': {
        lat: 38.6527,
        lng: -84.9585,
        zoom: 9
      }, //KT
      '5': {
        lat: 43.1939,
        lng: -71.5724,
        zoom: 6
      }, //Tire Warehouse
      '6': {
        lat: 38.6,
        lng: -90.4,
        zoom: 9
      },
      '7': {
        lat: 34.4,
        lng: -80.2,
        zoom: 6
      },
      '8': {
        lat: 27.9506,
        lng: -82.4572,
        zoom: 6
      }, //Tire choice
      '11': {
        lat: 36.05775,
        lng: -115.12306,
        zoom: 6
      }, // Superior Tire
      '12': {
        lat: 37.250031,
        lng: -121.866994,
        zoom: 9
      }, // Skip's Tire
      '13': {
        lat: 36.980505,
        lng: -122.02922,
        zoom: 9
      },// Lloyd's Tire
      '14': {
        lat: 36.206516,
        lng: -83.317469,
        zoom: 8
      },// Free Service Tire
      '15': {
        lat: 33.773406,
        lng: -118.007729,
        zoom: 9
      },// Allen Tire Company
      '16': {
        lat: 34.170780,
        lng: -118.339290,
        zoom: 9
      } // Mountain View Tire

    }

    return zoomCoords[brandId];
  }

  let setCookie = function (name, value, days = 180, domain) {       
    var expires = "";
    if (days) {
        var date = new Date(Date.now() + (1000 * 60 * 60 * 24 * days));
        expires = "; expires=" + date.toUTCString();
    }
    let domainStr = "";
    let pathStr = ";path=/";
    if (domain) {
        domainStr =`;Domain=${domain}`;
    }

    const cookieString = `${name}=${value || ""}${expires}${domainStr}${pathStr}`;
    document.cookie =  cookieString;
}

  let getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  let getParameterByName = (name) => {
    let url = window.location.href;
    let formattedName = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + formattedName + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  let getBreakpoint = (size) => {
    return breakpoints[size];
  }

  let lookupStarRating = (rating) => {
    let starRatingHtml = '';
    var i = 0;
    if (rating) {
      for (i = 0; i < rating - 1; i++) {
        starRatingHtml += `<i class="fa fa-star review-star"></i>`;
      }

      let remainder = Math.round((rating - i) * 10) / 10;
      if (remainder <= 0.5 && remainder > 0.1) {
        starRatingHtml += `<i class="fa fa-star-half-o review-star"></i>`;
      } else if (remainder >= 0.5) {
        starRatingHtml += `<i class="fa fa-star review-star"></i>`;
      }

      for (var j = 4; j > i; j--) {
        starRatingHtml += `<i class="fa fa-star-o review-star"></i>`;
      }
    } else {
      for (i = 0; i < 5; i++) {
        starRatingHtml += `<i class="fa fa-star-o review-star"></i>`;
      }
    }

    return starRatingHtml;
  }

  //This function has a php implementation in utils.php
  let getPromoDiscount = function (ruleId, quantity, price, percentOff, dollarAmount, minAmount) {
    let total = price * quantity;
    let rules = {
      1: buyXGetY(1, 1, quantity, dollarAmount, price, total), //buy 1 get 1 free
      2: buyXGetY(3, 1, quantity, dollarAmount, price, total), //buy 3 get 1 free
      3: flatDiscountMinTires(percentOff, dollarAmount, minAmount, total, 'percent', quantity, 4), //percent off with 4 tires
      4: flatDiscount(percentOff, dollarAmount, minAmount, total, 'percent'), //percent off amount
      5: flatDiscount(percentOff, dollarAmount, minAmount, total, 'percent'), //percent off with drive card
      6: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar'), //instant rebate
      7: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar'), //mail in rebate
      8: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar'), //instant and mail in rebate
      9: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar'), //rebate with drive card
      10: flatDiscountMinTires(percentOff, dollarAmount, minAmount, total, 'dollar', quantity, 4), //rebate with drive card with 4 tires
      15: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar'), //dollar off amount
      16: flatDiscountMinTires(percentOff, dollarAmount, minAmount, total, 'dollar', quantity, 4), //buy 4 tires get amount off
      17: flatDiscountMinTires(percentOff, dollarAmount, minAmount, total, 'dollar', quantity, 4), //buy 4 tires get reward card
      18: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar'), //flat rate
      19: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar'), //rebate card
      20: flatDiscountMinTires(percentOff, dollarAmount, minAmount, total, 'dollar', quantity, 4), //rebate with prepaid card with 4 tires
      22: flatDiscountMinTires(percentOff, dollarAmount, minAmount, total, 'dollar', quantity, 4), //rebate with 4 tires
      23: flatDiscountMinTires(percentOff, dollarAmount, minAmount, total, 'dollar', quantity, 4), //rebate with drive card with 4 tires
      24: flatDiscount(percentOff, dollarAmount, minAmount, total, 'dollar') //promotion per tire
    };

    return rules[ruleId];
  }


  //This function has a php implementation in utils.php
  let buyXGetY = function (x, y, quantity, dollarAmount, price, total) {
    let discount = 0;

    if (x === 3 && y === 1 && quantity >= 4 && quantity <= 8) {
      discount = price;

      if (quantity === 8) {
        discount = price * 2;
      }
      discount = Number(discount) + Number(dollarAmount)
      return discount;
    }

    if (x == 1 && y == 1 && quantity > 1) {
      return Number(Math.floor(quantity / 2) * price) + Number(dollarAmount);
    }

    return null;
  }

  let flatDiscount = function (percent, dollar, minimum, total, type) {
    if (total >= minimum) {
      if (type === 'dollar') {
        return dollar;
      } else if (type === 'percent') {
        return (parseFloat(total) * parseFloat(percent)).toFixed(2);
      }
    }
    return null;
  }


  let flatDiscountMinTires = function (percent, dollar, minimum, total, type, qty, minQty) {
    if (total >= minimum && qty >= minQty) {
      if (type === 'dollar') {
        return dollar;
      } else if (type === 'percent') {
        return (parseFloat(total) * parseFloat(percent)).toFixed(2);
      }
    }
    return null;
  }

  let getReviewCount = function (data) {
    let total = 0;
    let tread = 0;
    let comfort = 0;
    let traction = 0;
    let value = 0;

    for (const [key, review] of Object.entries(data)) {
        total += review.TireRating;
        tread += tireReviewMapping(review.TreadWearRating);
        comfort += tireReviewMapping(review.ComfortRating);
        traction += tireReviewMapping(review.TractionRating);
        value += tireReviewMapping(review.ValueRating);
    }

    const ratingInfo = {
      ReviewCount: data.length,
      Rating: data.length ? total / data.length : 0,
      TreadWearRating: data.length ? tread / data.length : 0,
      ComfortRating: data.length ? comfort / data.length : 0,
      TractionRating: data.length ? traction / data.length : 0,
      ValueRating: data.length ? value / data.length : 0,
    };

    return ratingInfo;
  }

  let tireReviewMapping = function (reviewRating) {
    let reviewRatingMap = {
      'poor': 1,
      'fair': 2,
      'neutral': 3,
      'good': 4,
      'excellent': 5
    }
    return reviewRatingMap[reviewRating.toLowerCase()];
  }

  //taken from https://stackoverflow.com/a/11381730/3715362
  let mobileAndTabletCheck = function () {
    var check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  // Returns a brands display name based on brandid from the database
  let lookupBrandDisplayName = (brandId) => {
    let brandDisplayMap = {
      1: 'Monro Auto Service and Tire Centers',
      2: 'Mr. Tire',
      3: 'Tire Barn',
      4: 'Ken Towery',
      5: 'Tire Warehouse',
      6: 'AutoTire',
      7: 'Tread Quarters',
      8: 'The Tire Choice',
      11: 'Superior Tire',
      12: 'Skip\'s Tire',
      13: 'Lloyd\'s Tire',
      14: 'Free Service Tire',
      15: 'Allen Tire Company',
      16: 'Mountain View Tire',
      22: 'Calabasas Car Care',
      23: 'Bud\'s Tires'
    }
    return brandDisplayMap[brandId];
  }

  let getBrandsAndUrls = () => {
    return { 
        'monro': 'https://monro.monrostaging.mindex.cloud',
        'mrtire': 'https://mrtire.monrostaging.mindex.cloud',
        'tirebarn': 'https://tirebarn.monrostaging.mindex.cloud',
        'kentowery': 'https://kentowery.monrostaging.mindex.cloud',
        'tirewarehouse': 'https://tirewarehouse.monrostaging.mindex.cloud',
        'thetirechoice': 'https://thetirechoice.monrostaging.mindex.cloud',
        'skipstire': 'https://skipstire.monrostaging.mindex.cloud',
        'lloydstire': 'https://lloydstire.monrostaging.mindex.cloud',
        'freeservicetire': 'https://freeservicetire.monrostaging.mindex.cloud',
        'allentireco': 'https://allentireco.monrostaging.mindex.cloud',
        'mountainview': 'https://mountainview.monrostaging.mindex.cloud',
        'calabasascarcare': 'https://calabasascarcare.monrostaging.mindex.cloud',
        'budstires': 'https://budstires.monrostaging.mindex.cloud'
    }
  }

  let lookupBrandUrls = (brandId) => {
    let brandUrlMap = {
      1: 'https://monro.monrostaging.mindex.cloud',
      2: 'https://mrtire.monrostaging.mindex.cloud',
      3: 'https://tirebarn.monrostaging.mindex.cloud',
      4: 'https://kentowery.monrostaging.mindex.cloud',
      5: 'https://tirewarehouse.monrostaging.mindex.cloud',
      8: 'https://thetirechoice.monrostaging.mindex.cloud',
      12: 'https://skipstire.monrostaging.mindex.cloud',
      13: 'https://lloydstire.monrostaging.mindex.cloud',
      14: 'https://freeservicetire.monrostaging.mindex.cloud',
      15: 'https://allentireco.monrostaging.mindex.cloud',
      16: 'https://mountainviewtire.monrostaging.mindex.cloud',
      22: 'https://calabasascarcare.monrostaging.mindex.cloud',
      23: 'https://budstires.monrostaging.mindex.cloud'
    }
    return brandUrlMap[brandId];
  }

  // Monro uses an internal Brand Id mapping that differs than what we use on the site, so this map is to manage the difference.
  let lookupInternalBrandIds = (brandId) => {
    let internalBrandIdMap = {
        1: 9, // Monro
        2: 1, // Mr. Tire
        3: 26, // Tire Barn
        4: 27, // Ken Towery
        5: 12, // Tire Warehouse
        8: 31, // The Tire Choice
        12: 38, // Skips Tire
        13: 39, // Lloyds Tire
        14: 36, // Free Service Tire
        15: 40, // Allen Tire Co
        16: 41, // Mountainview Tire
        22: 44, // Calabasas Car Care
        23: 43 // Buds Tires
    }
    return internalBrandIdMap[brandId];
  }

  let storeSelectRedirect = (selector) => {
    let redirect = `${location.pathname}${location.search ? location.search : ''}`;
    jQuery(selector).attr('href', '/store-search?redirect=' + encodeURIComponent(redirect));
  }

  let rerenderPhoneNumber = () => {
    //_st is created by the DialogTech script
    if (typeof _st !== 'undefined') {
      _st.render();
    }
  }

  let isProd = () => {
    return false;
  }

  let getDniColumn = () => {
    if(Util.getCookie('dni_column')) {
        return Util.getCookie('dni_column');
    } else {
        return 'websitereferral';
    }
  }

  const sendCouponSMSText = (couponID, customerPhone) => {
      jQuery.ajax({
          url: window.location.origin + '/wp-json/monro/v1/sms/coupon',
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({ couponID: couponID, customerPhone: customerPhone }),
          success: function(){ console.log('SMS Sent Message'); },
          error: function(xhr){ console.error('SMS Send failed', xhr && xhr.status, xhr && xhr.responseText); }
      });
  }

  return {
      setCookie: setCookie,
      getCookie: getCookie,
      lookupStarRating: lookupStarRating,
      getPromoDiscount: getPromoDiscount,
      getParameterByName: getParameterByName,
      getReviewCount: getReviewCount,
      tireReviewMapping: tireReviewMapping,
      getBreakpoint: getBreakpoint,
      setiFrameTitle: setiFrameTitle,
      lambdaHost: lambdaHost,
      lambdaApiKey: lambdaApiKey,
      lambdaHostAppt: lambdaHostAppt,
      lambdaApiKeyAppt: lambdaApiKeyAppt,
      emailApiHost: emailApiHost,
      emailApiKey: emailApiKey,
      mobileAndTabletCheck: mobileAndTabletCheck,
      scrollToTop: scrollToTop,
      lookupBrandDisplayName: lookupBrandDisplayName,
      lookupBrandUrls: lookupBrandUrls,
      getBrandsAndUrls: getBrandsAndUrls,
      lookupInternalBrandIds: lookupInternalBrandIds,
      storeSelectRedirect: storeSelectRedirect,
      closestLocationsMapZoom: closestLocationsMapZoom,
      rerenderPhoneNumber: rerenderPhoneNumber,
      isProd: isProd,
      getDniColumn: getDniColumn,
      sendCouponSMSText: sendCouponSMSText,
      s3ImageUrl: s3ImageUrl
  }
})();